/* eslint-disable */
import AjaxRequestManager from '../AjaxRequestManager';
import EntityManager from '../EntityManager';
import ResortFactory from '../Factory/Resort';
import ResortsRepository from '../Repository/Resorts'; //global state
import ResortEntity from '../Entity/Resort';
import CountryFactory from '../Factory/Country';
import CountriesRepository from '../Repository/Countries'; //global state
import HotelsRepository from '../Repository/Hotels'; //global state
import HotelFactory from '../Factory/Hotel';
import backboneModelDeepInstanceOf from '@/js/common/Domain/Service/backboneModelDeepInstanceOf';


const DestinationService = function(params) {
    const localCountryRepository = params?.localCountryRepository;

    var entityManager = new EntityManager(),
        ajaxRequestManager = new AjaxRequestManager({
			abortPrevious:false
		}),
        userInputTimeout,
        cache = {},
        globalCallback = {},
        self = this;

    this.getOptions = function(term, callback) {
        term = term.toLowerCase();
        delete(globalCallback.error);
        delete(globalCallback.success);
        globalCallback = callback;

        if (cache[term]) {
            callback && callback.success ? callback.success(cache[term]): null;
        } else {
            ajaxRequestManager.getData({
                url: window.appConfig.intelligentSearch,
                retriesAvailable: true,
                data: {
                    term: term
                }
            }, {
                success: function(data) {
                    var data = self.processData(data);

                    cache[term] = data;
                    callback && callback.success ? callback.success(data) : null;
                },
                error: function () {}
            });
        }

        clearTimeout(userInputTimeout);
        userInputTimeout = setTimeout(function() {
            console.log('IntelligentSearchInput:', term);
        }, 1000);
    };

    this.processData = function(destinationsData) {
        var data = [],
            processResort = function(resort) {
                var country,
                    countryResorts;

                country = resort.get('country');
                countryResorts = backboneModelDeepInstanceOf({model:country}) ? country.get('resorts') : null;
                if(!countryResorts) {
                    country.set('resorts', new ResortsRepository(resort));
                } else if(!countryResorts.contains(resort)){
                    countryResorts.add(resort);
                }
            };

        destinationsData = _.map(destinationsData, function(destination) {
            var factory,
                hotelResort,
                repository;

            switch (destination.type) {
                case 'country':
                    factory = CountryFactory;
                    repository = localCountryRepository || CountriesRepository.repository;
                    break;
                case 'resort':
                    factory = ResortFactory;
                    repository = ResortsRepository.repository;
                    break;
                case 'hotel':
                    factory = HotelFactory;
                    repository = HotelsRepository.repository;
                    break;
            }

            destination = entityManager.add({
                factory,
                repository,
                localCountryRepository: localCountryRepository,
            }, destination);

            if(destination instanceof ResortEntity) {
                processResort(destination);
            }

            return destination;
        });

        return destinationsData;
    };

    return this;
};

export default DestinationService;